/* eslint-disable */
export const AccessValues = ["INBOUND_CALL", "APP", "WEBSITE", "BOOK_DOC_AT_PHARMACY", "BOOK_DOC_AT_PARTNER", "WEB_BOOKING", "OUTBOUND_CALL", "PARTNER_PORTAL"] as const
export type Access = typeof AccessValues[number]

export const AccountVerificationStatusValues = ["IN_PROGRESS", "REJECTED", "VERIFIED"] as const
export type AccountVerificationStatus = typeof AccountVerificationStatusValues[number]

export const AimValues = ["ANALGESIA_ANTI_INFLAMMATORY_TREATMENT", "IMPROVEMENT_OF_JOINT_FUNCTION", "IMPROVEMENT_OF_MUSCLE_FUNCTION", "PROPRIOCEPTION_COORDINATION", "IMPROVEMENT_OF_CARDIO_PULMO_FUNCTION", "DECONGESTION", "IMPROVEMENT_OF_MOBILITY", "FUNCTIONAL_BANDAGE_TAPE", "INSTRUCTION"] as const
export type Aim = typeof AimValues[number]

export const AiResultValues = ["SUCCESS", "PROCESS_TIMEOUT", "UNKNOWN_ERROR", "MISSING_PROMPT_FOR_REQUESTED_LANGUAGE", "MAXIMUM_NUMBER_OF_TOKENS_EXCEEDED", "BREACHED_CONTENT_FILTER", "TOOL_CALLS", "FUNCTION_CALL", "JSON_ERROR", "NOT_FOUND_OPEN_AI_PROMPT", "MISSING_USER_PROMPT", "MISSING_APPOINTMENT_DATA", "UNRESOLVED_PLACEHOLDER", "INVALID_QUESTIONNAIRE_DATA", "UNSUPPORTED_PLACEHOLDER", "MISSING_USER_INPUT", "MISSING_QUESTIONNAIRE_DATA", "MISSING_CHAT_TRANSCRIPT", "APPOINTMENT_IS_MISSING_CHAT_THREAD_ID", "MISSING_CALL_TRANSCRIPT", "MISSING_CLINIBEE_GUIDELINES"] as const
export type AiResult = typeof AiResultValues[number]

export const ApplyPolicyValues = ["BEFORE_RESOLVER", "AFTER_RESOLVER", "VALIDATION"] as const
export type ApplyPolicy = typeof ApplyPolicyValues[number]

export const AppointmentReviewStatusValues = ["NONE", "NEEDED", "REVIEWED"] as const
export type AppointmentReviewStatus = typeof AppointmentReviewStatusValues[number]

export const AppointmentStatusValues = ["OPEN", "IN_PROGRESS", "CLOSED", "CANCELLED"] as const
export type AppointmentStatus = typeof AppointmentStatusValues[number]

export const AppointmentTagVariantValues = ["CRITICAL", "NEUTRAL", "WARNING", "MOST_CRITICAL", "SUCCESS", "ATTENTION"] as const
export type AppointmentTagVariant = typeof AppointmentTagVariantValues[number]

export const AppointmentTypeValues = ["NORMAL", "FOLLOW_UP", "LONGER", "FLAT_LENGTH_FULL_HOUR"] as const
export type AppointmentType = typeof AppointmentTypeValues[number]

export const AssociationTypeValues = ["MANDATORY", "OPTIONAL"] as const
export type AssociationType = typeof AssociationTypeValues[number]

export const AsynchronousQuestionnaireUsageValues = ["DECLINED", "ACCEPTED", "ALL"] as const
export type AsynchronousQuestionnaireUsage = typeof AsynchronousQuestionnaireUsageValues[number]

export const AsyncRequestStatusValues = ["APPROVED", "REJECTED"] as const
export type AsyncRequestStatus = typeof AsyncRequestStatusValues[number]

export const AttachmentsChangedReasonValues = ["UPLOAD_STATUS_CHANGED", "UPLOAD_SESSION_REVERTED"] as const
export type AttachmentsChangedReason = typeof AttachmentsChangedReasonValues[number]

export const AutoimmuneDiseaseValues = ["NOT_SPECIFIED", "UNKNOWN", "NO", "YES"] as const
export type AutoimmuneDisease = typeof AutoimmuneDiseaseValues[number]

export const BetterDocValues = ["ALLOWED", "NOT_ALLOWED", "REQUIRED", "CONDITION_PACKAGE"] as const
export type BetterDoc = typeof BetterDocValues[number]

export const BetterDocConsultationDetailValues = ["DIAGNOSIS_CODE", "SPECIALTY"] as const
export type BetterDocConsultationDetail = typeof BetterDocConsultationDetailValues[number]

export const BetterDocConsultationReasonValues = ["FIRST_SPECIALIST_CONSULTATION", "SPECIALIST_PREVENTIVE_CARE", "SPECIALIST_DIAGNOSTIC_PROCEDURE", "SECOND_OPINION", "SURGEON_WANTED", "SPECIALIST_HIGHER_SPECIALIZATION_WANTED", "SPECIALIST_CHANGE_PREFERRED"] as const
export type BetterDocConsultationReason = typeof BetterDocConsultationReasonValues[number]

export const BetterDocRejectionReasonValues = ["PATIENT_REFUSES_TO_USE_BETTER_DOC", "BETTER_DOC_CHOSE_CARE_PROVIDER_BEFOREHAND"] as const
export type BetterDocRejectionReason = typeof BetterDocRejectionReasonValues[number]

export const BetterDocResultStatusValues = ["INVALID_PATIENT", "INVALID_SPECIALTY", "BETTER_DOC_ERROR", "NO_RESULTS", "SUCCESS", "MANUAL_SEARCH_NEEDED"] as const
export type BetterDocResultStatus = typeof BetterDocResultStatusValues[number]

export const BillingLabelScopeValues = ["PRODUCT_CONFIGURATION", "WEB_BOOKING_PARTNER"] as const
export type BillingLabelScope = typeof BillingLabelScopeValues[number]

export const BloodChemistryValues = ["ALBUMIN", "ALK_PHOSPHOTASE", "AMYLASE", "BILIRUBIN", "BLOOD_SUGAR", "CHLORIDE", "CHOLSTEROL", "CHOLSTEROL_HDL", "CK", "CRP", "GAMMA_GT", "GPT_ALAT", "GOT_ASAT", "URIC_ACID", "UREA", "HDL", "POTASSIUM", "CREATININE", "LDH", "SODIUM", "NT_PRO_BNP", "PHOSPHATE", "TRIGLYCERIDE", "TROPONIN_T"] as const
export type BloodChemistry = typeof BloodChemistryValues[number]

export const CallerRoleValues = ["PATIENT", "DOMESTIC_PARTNER", "FATHER", "MOTHER", "SON", "DAUGHTER", "GRANDFATHER", "GRANDMOTHER", "PHARMACY", "OTHER"] as const
export type CallerRole = typeof CallerRoleValues[number]

export const CancerValues = ["NOT_SPECIFIED", "UNKNOWN", "NO", "YES"] as const
export type Cancer = typeof CancerValues[number]

export const CarePlanTherapyValues = ["PHYSIOTHERAPY", "PSYCHOTHERAPY", "NUTRITIONAL_COUNSELLING"] as const
export type CarePlanTherapy = typeof CarePlanTherapyValues[number]

export const CareProviderGroupSearchTypeValues = ["INLINE", "ADVANCE"] as const
export type CareProviderGroupSearchType = typeof CareProviderGroupSearchTypeValues[number]

export const CareProviderGroupTypeValues = ["NONE", "CHIROPRACTOR", "DENTIST", "NUTRITIONIST", "DOCTOR", "HOSPITAL", "PHARMACY", "PHYSIOTHERAPIST", "PSYCHOTHERAPIST"] as const
export type CareProviderGroupType = typeof CareProviderGroupTypeValues[number]

export const CareProviderSearchTypeValues = ["NONE", "ADVANCED_SEARCH", "GENERAL_PRACTITIONER", "SPECIALIST_WITHOUT_SPECIALTY", "SPECIALIST_WITH_SPECIALTY", "PRESCRIPTION_DOCUMENT", "THERAPY_PRESCRIPTION_NUTRITIONAL_COUNSELLING_DOCUMENT", "THERAPY_PRESCRIPTION_PHYSIOTHERAPY_DOCUMENT", "THERAPY_PRESCRIPTION_PSYCHOLOGICAL_PSYCHOTHERAPY_DOCUMENT", "THERAPY_PRESCRIPTION_NEUROPSYCHOLOGIC_DIAGNOSTIC_DOCUMENT", "TIME_WINDOW_WITH_REFERRAL_TO", "TIME_WINDOW_WITH_REFERRED_BY", "HOSPITAL_ELECTIVE_WITHOUT_SPECIALTY", "HOSPITAL_ELECTIVE_WITH_SPECIALTY", "HOSPITAL_EMERGENCY_ROOM", "MEDICAL_EMERGENCY_OR_PERMANENCE"] as const
export type CareProviderSearchType = typeof CareProviderSearchTypeValues[number]

export const CertificateValues = ["FIRST", "FOLLOW_UP"] as const
export type Certificate = typeof CertificateValues[number]

export const CertificateTypeValues = ["FIRST", "FOLLOW_UP"] as const
export type CertificateType = typeof CertificateTypeValues[number]

export const ch_BillingTargetValues = ["NONE", "CANTON_WALLIS", "CANTON_APPENZELL_INNERRHODEN", "SWICA_OVERFLOW"] as const
export type ch_BillingTarget = typeof ch_BillingTargetValues[number]

export const ch_InsuranceCareProviderListEntryStatusValues = ["MATCHED", "UNMATCHED", "DUPLICATE", "INVALID"] as const
export type ch_InsuranceCareProviderListEntryStatus = typeof ch_InsuranceCareProviderListEntryStatusValues[number]

export const ch_InsuranceCareProviderListFileFormatErrorValues = ["FILE_TOO_LARGE", "MISSING_COLUMNS", "UNREADABLE"] as const
export type ch_InsuranceCareProviderListFileFormatError = typeof ch_InsuranceCareProviderListFileFormatErrorValues[number]

export const ch_InsuranceImportFormatValues = ["CSV_TAB", "FIXED_LENGTH", "CSV_TAB_V2", "FIXED_LENGTH_V2"] as const
export type ch_InsuranceImportFormat = typeof ch_InsuranceImportFormatValues[number]

export const ch_InsuranceImportStatusValues = ["PENDING", "VALIDATING", "VALIDATED", "FILES_UPLOADING", "FILES_UPLOADED", "PROCESSING_INSURANCE_FILES", "IMPORT_TO_SOFIA", "COMPLETED", "COMPLETED_WITH_WARNINGS", "FAILED_UNEXPECTEDLY", "FAILED_NOT_CONFIGURED", "FAILED_FILE_PREFIX_MISMATCH", "FAILED_EMPTY_FILE", "FAILED_DUPLICATE_FILE_NAME", "FAILED_UNKNOWN_FORMAT", "FAILED_FORMAT_MISMATCH", "FAILED_FILE_UPLOAD", "FAILED_PROCESSING_UNEXPECTEDLY", "FAILED_BUSINESS_VALIDATION", "DISCOVERING_SOURCE_FILES", "SOURCE_NOT_CONFIGURED", "SOURCE_CONNECTION_FAILED", "SOURCE_NO_COMPLETE_FILE_SET", "SOURCE_TRANSFER_FAILED", "SOURCE_PACKAGE_OUTDATED", "SOURCE_VOLUME_DROP_TOO_LARGE", "SKIPPED_NO_NEW_DATA", "SOURCE_PACKAGE_STILL_UPLOADING", "SKIPPED_IMPORT_ONGOING", "RUN_CANCELLED"] as const
export type ch_InsuranceImportStatus = typeof ch_InsuranceImportStatusValues[number]

export const ch_InsuranceImportTypeValues = ["MANUAL", "AUTOMATIC"] as const
export type ch_InsuranceImportType = typeof ch_InsuranceImportTypeValues[number]

export const ch_InsuranceImportWarningTypeValues = ["UNCONFIGURED_IMPORT_CODE", "UNCONFIGURED_IMPORT_CODE_NO_ACTIVE_COVERAGE", "MISSING_INSURANCE_NUMBER", "MISSING_INSURANCE_CARD_NUMBER", "MISSING_COUNTRY", "MISSING_ADDRESS", "MEDGATE_PRODUCT_CONFIGURATION_MAPS_UNUSED_IMPORT_CODES", "NOT_CONFIGURED", "FILE_PREFIX_MISMATCH", "EMPTY_FILE", "DUPLICATE_FILE_NAME", "UNKNOWN_FORMAT", "FORMAT_MISMATCH", "FILE_UPLOAD_FAILED", "UNEXPECTED_ERROR", "AUTOMATIC_IMPORT_NOT_CONFIGURED", "IMPORT_ONGOING", "NO_NEW_DATA", "RUN_CANCELLED", "SOURCE_UNREACHABLE", "SOURCE_AUTHENTICATION_FAILED", "SOURCE_HOST_KEY_MISMATCH", "SOURCE_PATH_NOT_FOUND", "SOURCE_FILE_NAME_UNPARSEABLE", "SOURCE_FILE_STILL_BEING_WRITTEN", "SOURCE_FILE_TRANSFER_INCOMPLETE", "SOURCE_FILE_BELOW_MINIMUM_ENTRIES", "SOURCE_FILE_COUNT_MISMATCH", "SOURCE_FILE_SET_INCOMPLETE", "SOURCE_PACKAGE_OLDER_THAN_LAST_IMPORT", "SOURCE_PACKAGE_REDELIVERED", "VOLUME_DROP_EXCEEDS_LIMIT", "VOLUME_DROP_LIMIT_BYPASSED", "VOLUME_CHANGE_EXCEEDS_THRESHOLD", "RETRIGGERED_FROM_PREVIOUS_IMPORT", "RETRIGGERED_NOT_LATEST_PACKAGE"] as const
export type ch_InsuranceImportWarningType = typeof ch_InsuranceImportWarningTypeValues[number]

export const ch_InsureeWelcomeLetterDeliveredChannelValues = ["DIGITAL", "PHYSICAL"] as const
export type ch_InsureeWelcomeLetterDeliveredChannel = typeof ch_InsureeWelcomeLetterDeliveredChannelValues[number]

export const ch_InsureeWelcomeLetterStatusValues = ["NOT_APPLICABLE", "NOT_SENT", "MISSING_REQUIRED_DATA", "EXCLUDED_BY_CUT_OFF_DATE", "EXCLUDED_SINCE_COVERAGE_ENDS_SOON", "IN_DELIVERY", "REJECTED", "SUCCESSFUL_DELIVERY", "FAILED_DELIVERY", "WAITING_FOR_RELEASE", "RELEASED_FOR_SENDING"] as const
export type ch_InsureeWelcomeLetterStatus = typeof ch_InsureeWelcomeLetterStatusValues[number]

export const ch_WelcomeLetterDispatchChannelValues = ["DIGITAL", "PHYSICAL"] as const
export type ch_WelcomeLetterDispatchChannel = typeof ch_WelcomeLetterDispatchChannelValues[number]

export const ch_WelcomeLetterDispatchKindValues = ["FIRST", "ADDRESS_CORRECTION_RESEND"] as const
export type ch_WelcomeLetterDispatchKind = typeof ch_WelcomeLetterDispatchKindValues[number]

export const ch_WelcomeLetterDispatchStatusValues = ["IN_DELIVERY", "SUCCESSFUL_DELIVERY", "FAILED_DELIVERY"] as const
export type ch_WelcomeLetterDispatchStatus = typeof ch_WelcomeLetterDispatchStatusValues[number]

export const ch_WelcomeLetterManualReleaseStatusValues = ["WAITING_FOR_RELEASE", "RELEASED_FOR_SENDING"] as const
export type ch_WelcomeLetterManualReleaseStatus = typeof ch_WelcomeLetterManualReleaseStatusValues[number]

export const ch_WelcomeLetterReleaseResultValues = ["RELEASED", "NO_LONGER_WAITING", "NOT_FOUND"] as const
export type ch_WelcomeLetterReleaseResult = typeof ch_WelcomeLetterReleaseResultValues[number]

export const ChatSenderKindValues = ["PATIENT", "AGENT", "SYSTEM"] as const
export type ChatSenderKind = typeof ChatSenderKindValues[number]

export const ChatTemplateTypeValues = ["MEDICAL", "ADMINISTRATIVE"] as const
export type ChatTemplateType = typeof ChatTemplateTypeValues[number]

export const ChMedicationTypeValues = ["SUBSTANCE", "PREPARATION", "TEMPLATE", "FREE_TEXT_MEDICATION"] as const
export type ChMedicationType = typeof ChMedicationTypeValues[number]

export const CoagulationValues = ["D_DIMER", "INR", "QUICK"] as const
export type Coagulation = typeof CoagulationValues[number]

export const CommunicationChannelValues = ["VIDEO", "PHONE", "CHAT", "ASYNC_REQUEST"] as const
export type CommunicationChannel = typeof CommunicationChannelValues[number]

export const ConclusionStatusValues = ["IN_CONCLUSION", "CONCLUDED", "FAILED"] as const
export type ConclusionStatus = typeof ConclusionStatusValues[number]

export const ConditionStageValues = ["ACUTE", "SUBACUTE", "CHRONIC"] as const
export type ConditionStage = typeof ConditionStageValues[number]

export const ConsentStateValues = ["UNKNOWN", "GRANTED", "DENIED"] as const
export type ConsentState = typeof ConsentStateValues[number]

export const ConsultationFeedbackReasonValues = ["AREA_OF_EXPERTISE", "LANGUAGE_CONFIDENCE", "AGE_BAND", "OTHER"] as const
export type ConsultationFeedbackReason = typeof ConsultationFeedbackReasonValues[number]

export const ConsultQueueKindValues = ["MEDICAL_SUPERVISOR", "OPERATIONS_LEAD", "DOCTOR", "PEDIATRIC"] as const
export type ConsultQueueKind = typeof ConsultQueueKindValues[number]

export const ContactChannelValues = ["APP", "EMAIL_AND_SMS", "NO_CHANNEL"] as const
export type ContactChannel = typeof ContactChannelValues[number]

export const CountryValues = ["DE", "CH"] as const
export type Country = typeof CountryValues[number]

export const CoverageIssueKindValues = ["MULTIPLE_COMPULSORY_COVERAGES", "POTENTIAL_PATIENT_MISMATCH", "PATIENT_MISMATCH"] as const
export type CoverageIssueKind = typeof CoverageIssueKindValues[number]

export const CriticalityLevelValues = ["INFO", "WARNING", "CRITICAL"] as const
export type CriticalityLevel = typeof CriticalityLevelValues[number]

export const DaylightSavingTimeChangeValues = ["NONE", "SUMMER_TIME_TO_WINTER_TIME", "WINTER_TIME_TO_SUMMER_TIME"] as const
export type DaylightSavingTimeChange = typeof DaylightSavingTimeChangeValues[number]

export const DayOfWeekValues = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"] as const
export type DayOfWeek = typeof DayOfWeekValues[number]

export const de_BetterDocAnamnesisInfoSchemaAttributeActionValues = ["TRANSFORM", "DISCARD"] as const
export type de_BetterDocAnamnesisInfoSchemaAttributeAction = typeof de_BetterDocAnamnesisInfoSchemaAttributeActionValues[number]

export const de_BetterDocAnamnesisInfoSchemaStatusValues = ["ACTIVE", "INACTIVE", "FUTURE"] as const
export type de_BetterDocAnamnesisInfoSchemaStatus = typeof de_BetterDocAnamnesisInfoSchemaStatusValues[number]

export const de_BetterDocAnamnesisInfoSchemaValueTypeValues = ["TEXT", "WHOLE_NUMBER", "NUMBER", "BOOLEAN", "JSON_OBJECT", "JSON_ARRAY"] as const
export type de_BetterDocAnamnesisInfoSchemaValueType = typeof de_BetterDocAnamnesisInfoSchemaValueTypeValues[number]

export const de_BetterDocBodyRegionValues = ["EYES", "BLOOD_AND_BLOOD_CANCER", "BRAIN_NERVES_AND_CHRONIC_PAIN", "REPRODUCTIVE_ORGANS_AND_FERTILITY", "EAR_NOSE_AND_THROAT", "URINARY_TRACT_AND_KIDNEYS", "SKIN_AND_RECONSTRUCTIVE_SURGERY", "HEART_AND_BLOOD_VESSELS", "HORMONES_AND_METABOLISM", "CHILDREN_AND_ADOLESCENTS", "LUNGS_AND_RESPIRATORY_TRACT", "PLASTIC_AND_AESTHETIC_SURGERY", "PROSTATE", "MENTAL_HEALTH", "RHEUMATIC_DISEASES", "DIGESTIVE_ORGANS", "TEETH_AND_JAW", "BONES_JOINTS_AND_MUSCULOSKELETAL_SYSTEM"] as const
export type de_BetterDocBodyRegion = typeof de_BetterDocBodyRegionValues[number]

export const de_BetterDocCareProviderSearchStatusValues = ["SUCCESS", "INVALID_SEARCH_INPUT", "INVALID_SPECIALTY", "PROGRESS_NOTE_NOT_FOUND", "BETTER_DOC_UNAVAILABLE"] as const
export type de_BetterDocCareProviderSearchStatus = typeof de_BetterDocCareProviderSearchStatusValues[number]

export const de_BetterDocChildAndAdolescentCheckUpValues = ["NEWBORN_FIRST_EXAMINATION", "DAYS_3_TO_10", "WEEKS_4_TO_5", "MONTHS_3_TO_4", "MONTHS_6_TO_7", "MONTHS_10_TO_12", "MONTHS_21_TO_24", "MONTHS_34_TO_36", "MONTHS_46_TO_48", "MONTHS_60_TO_64", "YEARS_12_TO_14", "YEARS_16_TO_17"] as const
export type de_BetterDocChildAndAdolescentCheckUp = typeof de_BetterDocChildAndAdolescentCheckUpValues[number]

export const de_BetterDocConsultationReasonValues = ["SPECIALIST_PREVENTIVE_CARE", "SPECIALIST_DIAGNOSTIC_PROCEDURE", "SURGEON_WANTED", "SECOND_OPINION", "PSYCHOTHERAPIST_PSYCHIATRIST", "GENERAL_PRACTITIONER", "FIRST_SPECIALIST_CONSULTATION"] as const
export type de_BetterDocConsultationReason = typeof de_BetterDocConsultationReasonValues[number]

export const de_BetterDocExchangeOperationValues = ["CREATE_RECOMMENDATION", "SEARCH_CARE_PROVIDERS", "GET_RECOMMENDATION", "SEND_REFERRAL_SLIP", "SIMULATE_RESEARCH", "LIST_RECOMMENDATIONS", "SELECT_MEDIC", "SIMULATE_PATIENT_SELECTION", "SIMULATE_SECOND_OPINION_VISIT_CONFIRMATION", "CANCEL_RECOMMENDATION", "GET_ANAMNESIS_INFO_SCHEMAS"] as const
export type de_BetterDocExchangeOperation = typeof de_BetterDocExchangeOperationValues[number]

export const de_BetterDocExchangeOutcomeValues = ["PENDING", "RESPONDED", "TIMED_OUT", "CANCELLED", "TOKEN_UNAVAILABLE", "FAILED"] as const
export type de_BetterDocExchangeOutcome = typeof de_BetterDocExchangeOutcomeValues[number]

export const de_BetterDocExcludingDiagnosisValues = ["URETHRAL_STRICTURE", "PROSTATE_CANCER_SUSPECTED_OR_CONFIRMED", "WOUND_HEALING_DISORDER", "VARICOSE_VEINS", "MIGRAINE_OR_CHRONIC_HEADACHES", "MULTIPLE_SCLEROSIS", "EPILEPSY", "CORONARY_ARTERY_DISEASE", "HYPERTENSION", "CROHNS_DISEASE", "ULCERATIVE_COLITIS", "GALLSTONES", "SUSPECTED_COLORECTAL_CANCER", "RECTAL_PROLAPSE", "ANAL_FISTULA", "ANAL_FISSURE", "ANAL_ABSCESS", "PILONIDAL_SINUS", "FECAL_INCONTINENCE", "OTHER_ANAL_OR_PERIANAL_SYMPTOMS", "HEMORRHOIDS"] as const
export type de_BetterDocExcludingDiagnosis = typeof de_BetterDocExcludingDiagnosisValues[number]

export const de_BetterDocGenderValues = ["MALE", "FEMALE", "OTHER"] as const
export type de_BetterDocGender = typeof de_BetterDocGenderValues[number]

export const de_BetterDocPreventiveCareScreeningValues = ["ABDOMINAL_AORTIC_ANEURYSM_SCREENING", "BREAST_CANCER_SCREENING", "CHLAMYDIA_SCREENING", "COLORECTAL_CANCER_SCREENING", "HEALTH_CHECKUP", "SKIN_CANCER_SCREENING", "CANCER_SCREENING_FOR_WOMEN", "CANCER_SCREENING_FOR_MEN", "TRAVEL_VACCINATIONS", "PREGNANCY_CARE", "CHILD_AND_ADOLESCENT_SCREENING", "DENTAL_CHECKUP"] as const
export type de_BetterDocPreventiveCareScreening = typeof de_BetterDocPreventiveCareScreeningValues[number]

export const de_BetterDocPreviousDoctorValues = ["GENERAL_PRACTITIONER", "SPECIALIST", "NONE"] as const
export type de_BetterDocPreviousDoctor = typeof de_BetterDocPreviousDoctorValues[number]

export const de_BetterDocProgressNoteResultKindValues = ["CARE_PROVIDERS_RECOMMENDED", "NO_RESULT", "MSN"] as const
export type de_BetterDocProgressNoteResultKind = typeof de_BetterDocProgressNoteResultKindValues[number]

export const de_BetterDocRecommendationDeliveryValues = ["PMN", "MSN"] as const
export type de_BetterDocRecommendationDelivery = typeof de_BetterDocRecommendationDeliveryValues[number]

export const de_BetterDocRecommendationStateValues = ["TRIAGING", "NO_SERVICE", "SERVICE_TRIAGE_FAILED", "PENDING", "ADMITTING", "ADMISSION_FAILED", "ADMITTED", "RESEARCHING", "RESEARCH_FAILED", "RECOMMENDED", "MEDIC_SELECTED", "MEDIC_CONFIRMED", "REJECTED"] as const
export type de_BetterDocRecommendationState = typeof de_BetterDocRecommendationStateValues[number]

export const de_BetterDocRecommendationStateGroupValues = ["OPEN", "RECOMMENDED", "SELECTED", "REJECTED", "FAILED"] as const
export type de_BetterDocRecommendationStateGroup = typeof de_BetterDocRecommendationStateGroupValues[number]

export const de_BetterDocRemoteRequestStatusValues = ["RECEIVED", "INVALID_RECOMMENDATION_ID", "NOT_FOUND", "REQUEST_FAILED", "UNEXPECTED_RESPONSE"] as const
export type de_BetterDocRemoteRequestStatus = typeof de_BetterDocRemoteRequestStatusValues[number]

export const de_BetterDocSecondOpinionValues = ["NOT_APPLICABLE", "REQUIRED", "NOT_REQUIRED"] as const
export type de_BetterDocSecondOpinion = typeof de_BetterDocSecondOpinionValues[number]

export const de_BetterDocSelectionTypeValues = ["MEDIC", "ACTIVITY"] as const
export type de_BetterDocSelectionType = typeof de_BetterDocSelectionTypeValues[number]

export const de_BetterDocSessionStepTypeValues = ["RECOMMENDATION_REQUESTED", "REQUEST_FAILED", "CREDENTIALS_REJECTED", "VALIDATION_REJECTED", "RATE_LIMITED", "RECOMMENDATION_NOT_FOUND", "UNEXPECTED_RESPONSE", "PMN_RECOMMENDATION_RECEIVED", "RECOMMENDATION_PENDING", "EXISTING_RECOMMENDATION_RECEIVED", "REFERRAL_SLIP_SENT", "RESEARCH_REQUESTED", "PATIENT_SELECTION_REQUESTED", "MEDIC_SELECTION_REQUESTED", "SECOND_OPINION_VISIT_CONFIRMATION_REQUESTED", "CANCELLATION_REQUESTED", "FAILED_RECOMMENDATION_RECEIVED"] as const
export type de_BetterDocSessionStepType = typeof de_BetterDocSessionStepTypeValues[number]

export const de_BetterDocSpecificExaminationValues = ["CT", "MRI", "X_RAY", "ULTRASOUND", "ALLERGY_TEST", "STRESS_ECG", "COLONOSCOPY", "DUPLEX_ULTRASOUND", "DXA_BONE_DENSITY_SCAN", "ECHOCARDIOGRAPHY", "HEARING_TEST", "BONE_SCINTIGRAPHY", "LONG_TERM_BLOOD_PRESSURE", "LONG_TERM_ECG", "PULMONARY_FUNCTION_TEST", "GASTROINTESTINAL_ENDOSCOPY", "GASTROSCOPY", "POLYGRAPHY_SLEEP_STUDY", "PROCTOLOGICAL_EXAMINATION", "RESTING_ECG", "THYROID_SCINTIGRAPHY", "VISION_TEST", "VENOUS_DIAGNOSTICS"] as const
export type de_BetterDocSpecificExamination = typeof de_BetterDocSpecificExaminationValues[number]

export const de_BetterDocSubSpecialityValues = ["CYTOPATHOLOGY_PATHOLOGY", "DERMATOPATHOLOGY", "DEVELOPMENTAL_PEDIATRICS", "DIAGNOSTIC_NEURORADIOLOGY", "EAR_NOSE_THROAT_PHONIATRICS", "FETOMATERNAL_MEDICINE", "GENERAL_SURGERY_TRAUMATOLOGY", "GERIATRICS", "GYNECOLOGIC_ONCOLOGY", "GYNECOLOGICAL_SENOLOGY", "HEPATOLOGY", "INFECTION_PREVENTION_AND_CONTROL", "INVASIVE_NEURORADIOLOGY", "MOLECULAR_PATHOLOGY", "NEONATOLOGY", "NEUROPAEDIATRICS", "NEUROUROLOGY", "OPERATIVE_GYNECOLOGY_AND_OBSTETRICS", "OPERATIVE_UROLOGY", "OPHTHALMOLOGY", "PEDIATRIC_CARDIOLOGY", "PEDIATRIC_SURGERY_EMERGENCY_MEDICINE", "PEDIATRIC_EMERGENCY_MEDICINE", "PEDIATRIC_ENDOCRINOLOGY_DIABETOLOGY", "PEDIATRIC_GASTROENTEROLOGY_AND_HEPATOLOGY", "PEDIATRIC_NEPHROLOGY", "PEDIATRIC_ONCOLOGY_HEMATOLOGY", "PEDIATRIC_PNEUMOLOGY", "PEDIATRIC_RADIOLOGY", "PEDIATRIC_RHEUMATOLOGY", "REPRODUCTIVE_MEDICINE_AND_GYNECOLOGICAL_ENDOCRINOLOGY", "SURGICAL_SENOLOGY", "UROGYNECOLOGY", "UROLOGY_FOR_WOMEN", "VISCERAL_SURGERY"] as const
export type de_BetterDocSubSpeciality = typeof de_BetterDocSubSpecialityValues[number]

export const de_BetterDocSymptomLocationValues = ["SHOULDER", "ELBOW", "HAND_AND_WRIST", "FOOT_AND_ANKLE", "SPINE_AND_BACK", "HIP", "KNEE"] as const
export type de_BetterDocSymptomLocation = typeof de_BetterDocSymptomLocationValues[number]

export const de_BetterDocTestCaseOutcomeValues = ["PMN_RECEIVED", "PENDING", "EXISTING_RECOMMENDATION", "RECOMMENDATION_FAILED", "REQUEST_FAILED", "UNEXPECTED_RESPONSE"] as const
export type de_BetterDocTestCaseOutcome = typeof de_BetterDocTestCaseOutcomeValues[number]

export const de_BetterDocTestCaseScenarioValues = ["PMN", "MSN", "MSN_WITH_SECOND_OPINION"] as const
export type de_BetterDocTestCaseScenario = typeof de_BetterDocTestCaseScenarioValues[number]

export const de_InsuranceImportStatusValues = ["PENDING", "VALIDATING", "VALIDATED", "FILE_UPLOADING", "FILE_UPLOADED", "PROCESSING_INSURANCE_FILE", "IMPORT_TO_SOFIA", "COMPLETED", "COMPLETED_WITH_WARNINGS", "FAILED_UNEXPECTEDLY", "FAILED_NOT_CONFIGURED", "FAILED_EMPTY_FILE", "FAILED_HEADER_MISMATCH", "FAILED_INVALID_ENCODING", "FAILED_FILE_UPLOAD", "FAILED_PROCESSING_UNEXPECTEDLY", "FAILED_BUSINESS_VALIDATION"] as const
export type de_InsuranceImportStatus = typeof de_InsuranceImportStatusValues[number]

export const de_InsuranceImportTypeValues = ["MANUAL"] as const
export type de_InsuranceImportType = typeof de_InsuranceImportTypeValues[number]

export const de_InsuranceImportWarningTypeValues = ["EMPTY_FILE", "HEADER_MISMATCH", "INVALID_ENCODING", "NOT_CONFIGURED", "FILE_UPLOAD_FAILED", "MISSING_REQUIRED_VALUE", "UNREADABLE_VALUE", "INCONSISTENT_INSUREE_DATA", "INVALID_DATE_ORDER", "BIRTH_DATE_NOT_IN_PAST", "OVERLAPPING_COVERAGE_PERIODS", "DUPLICATE_ROW", "INVALID_COVERAGE_TYPE", "COVERAGE_TYPE_MISMATCH", "UNCONFIGURED_IMPORT_CODE", "UNEXPECTED_ERROR"] as const
export type de_InsuranceImportWarningType = typeof de_InsuranceImportWarningTypeValues[number]

export const de_RequestBetterDocRecommendationOutcomeValues = ["PMN_RECEIVED", "PENDING", "EXISTING_RECOMMENDATION", "RECOMMENDATION_FAILED"] as const
export type de_RequestBetterDocRecommendationOutcome = typeof de_RequestBetterDocRecommendationOutcomeValues[number]

export const DeMedicationTypeValues = ["SUBSTANCE", "PREPARATION", "FREE_TEXT_MEDICATION"] as const
export type DeMedicationType = typeof DeMedicationTypeValues[number]

export const DiabetesValues = ["NOT_SPECIFIED", "UNKNOWN", "NO", "YES_DIABETES_TYPE_ONE", "YES_DIABETES_TYPE_TWO", "YES_DIABETES_TYPE_ONE_AND_TWO"] as const
export type Diabetes = typeof DiabetesValues[number]

export const DisplayForValues = ["NONE", "CALL_CENTER_AGENT", "DOCTOR", "CUSTOMER_SERVICE_CENTER", "NURSING_PROFESSIONAL"] as const
export type DisplayFor = typeof DisplayForValues[number]

export const DoctorNetworkRoleValues = ["FAMILY_DOCTOR", "SPECIALIST", "GATEKEEPER"] as const
export type DoctorNetworkRole = typeof DoctorNetworkRoleValues[number]

export const DocumentTypeValues = ["PHOTO", "VIDEO", "PDF", "AUDIO"] as const
export type DocumentType = typeof DocumentTypeValues[number]

export const DrinkingHabitValues = ["NOT_SPECIFIED", "DAILY", "FOUR_TO_FIVE_PER_WEEK", "ONE_TO_THREE_PER_WEEK", "LESS_THAN_ONE_TIMES_PER_WEEK", "NO_LONGER", "NEVER"] as const
export type DrinkingHabit = typeof DrinkingHabitValues[number]

export const ExaminationTypeValues = ["LABORATORY_PHARMACY", "LABORATORY_PROFILE", "LONG_TERM_MEDICATION", "MICROBIOLOGY_AND_INFECTION_SEROLOGY", "ALLERGOLOGIE", "BLOOD_CHEMISTRY", "HEMATOLOGY", "COAGULATION", "URIN_DIAGNOSTICS", "ADDITIONAL_PARAMETER"] as const
export type ExaminationType = typeof ExaminationTypeValues[number]

export const ExternalLaboratoryValues = ["CA_KORR_ALB", "PROTEIN_OVERALL", "FERRITIN", "FOLATE", "MAGNESIUM", "PHOSPHATE", "PROTEIN_EP", "PSA_FPSA", "TSH", "VIT_B12", "VIT_D25_OH"] as const
export type ExternalLaboratory = typeof ExternalLaboratoryValues[number]

export const FeatureFlagTypeValues = ["B2B_DATA_IMPORT_ENABLED", "CHAT_AUTO_TRANSLATION", "GENESYS_TELEPHONY", "SPEECH_TO_TEXT"] as const
export type FeatureFlagType = typeof FeatureFlagTypeValues[number]

export const FileUploadRequestStatusValues = ["PENDING", "UPLOADED", "CANCELED", "CLOSED"] as const
export type FileUploadRequestStatus = typeof FileUploadRequestStatusValues[number]

export const FileUploadRequestTypeValues = ["DOCUMENT_REQUIRED", "PHOTOS_REQUIRED", "INSUFFICIENT_QUALITY_OF_PHOTOS", "AFFECTED_AREA_NOT_VISIBLE"] as const
export type FileUploadRequestType = typeof FileUploadRequestTypeValues[number]

export const FileUploadSourceValues = ["SOFIA", "PATIENT", "DOC2_U"] as const
export type FileUploadSource = typeof FileUploadSourceValues[number]

export const FileUploadStatusValues = ["UPLOADED", "NO_THREAT_FOUND", "MALICIOUS", "ERROR", "SCAN_TIMEOUT", "HYPERLINK_PROCESSING_FAILED", "JAVA_SCRIPT_PROCESSING_FAILED"] as const
export type FileUploadStatus = typeof FileUploadStatusValues[number]

export const FlexibilityValues = ["NOT_EARLIER", "FLEXIBLE", "FIXED_TIME"] as const
export type Flexibility = typeof FlexibilityValues[number]

export const GatekeeperValues = ["MEDGATE_ONLY", "MEDGATE_AND_OTHERS", "NOT_MEDGATE", "GENERAL_PRACTITIONER", "NO_GATEKEEPER"] as const
export type Gatekeeper = typeof GatekeeperValues[number]

export const GenderValues = ["UNKNOWN", "FEMALE", "MALE", "OTHER"] as const
export type Gender = typeof GenderValues[number]

export const GeoObjectTypeValues = ["POINT", "MULTI_POINT", "POLYGON", "MULTI_POLYGON", "LINE_STRING", "MULTI_LINE_STRING", "GEOMETRY_COLLECTION"] as const
export type GeoObjectType = typeof GeoObjectTypeValues[number]

export const GroupLevelValues = ["NONE", "GROUP", "SUBGROUP"] as const
export type GroupLevel = typeof GroupLevelValues[number]

export const GuidelineAgeGroupValues = ["NOT_RELEVANT", "MINOR", "MAJOR"] as const
export type GuidelineAgeGroup = typeof GuidelineAgeGroupValues[number]

export const HealthInformationStatusValues = ["UNKNOWN", "NONE", "SOME"] as const
export type HealthInformationStatus = typeof HealthInformationStatusValues[number]

export const HealthInformationTypeValues = ["BODY_MEASUREMENT", "CONDITION", "ALLERGY", "GYNAECOLOGY", "SOCIAL_HISTORY", "FAMILY_HISTORY"] as const
export type HealthInformationType = typeof HealthInformationTypeValues[number]

export const HeartDiseaseValues = ["NOT_SPECIFIED", "UNKNOWN", "NO", "YES"] as const
export type HeartDisease = typeof HeartDiseaseValues[number]

export const HematologyValues = ["HAEMOGRAM_II", "HAEMOGRAM_V", "HBA1_C"] as const
export type Hematology = typeof HematologyValues[number]

export const IcdCodesSearchTypeValues = ["EPISODE_OF_CARE", "CONDITION", "ALLERGY"] as const
export type IcdCodesSearchType = typeof IcdCodesSearchTypeValues[number]

export const InsurerGroupValues = ["RVK", "GROUPE_MUTUEL"] as const
export type InsurerGroup = typeof InsurerGroupValues[number]

export const LangfusePromptValidationStatusValues = ["ACTIVE", "NO_USER_PROMPT", "MISSING_PLACEHOLDERS", "INVALID_PLACEHOLDERS"] as const
export type LangfusePromptValidationStatus = typeof LangfusePromptValidationStatusValues[number]

export const LanguageValues = ["GERMAN", "FRENCH", "ITALIAN", "ENGLISH"] as const
export type Language = typeof LanguageValues[number]

export const LastUserSyncStatusValues = ["CREATED", "CHANGED", "UNCHANGED", "DELETED", "FAILED"] as const
export type LastUserSyncStatus = typeof LastUserSyncStatusValues[number]

export const LawValues = ["KVG", "VVG", "UVG", "IVG", "MVG", "ORG"] as const
export type Law = typeof LawValues[number]

export const LegitimateInterestStateValues = ["UNKNOWN", "CLAIMED", "OBJECTED"] as const
export type LegitimateInterestState = typeof LegitimateInterestStateValues[number]

export const LineTypeValues = ["KIDS_LINE", "EMERGENCY_LINE", "TELE_GENERAL_PRACTITIONER_LINE", "SWICA_OVERFLOW"] as const
export type LineType = typeof LineTypeValues[number]

export const MagicWandTypeValues = ["ANAMNESE", "EXPLAIN", "NICE_SPEAK", "THERAPY"] as const
export type MagicWandType = typeof MagicWandTypeValues[number]

export const MedgateConnectChannelValues = ["PATIENT", "PARTNER"] as const
export type MedgateConnectChannel = typeof MedgateConnectChannelValues[number]

export const MedgateConnectOrderStatusValues = ["OPEN", "FULFILLED", "CLOSED"] as const
export type MedgateConnectOrderStatus = typeof MedgateConnectOrderStatusValues[number]

export const MedicalPrescriptionValues = ["PROGRESS_ASSESSMENT", "DIAGNOSTIC_NEUROPSYCHOLOGY_FOR_SUSPECTED_BRAIN_DISORDERS"] as const
export type MedicalPrescription = typeof MedicalPrescriptionValues[number]

export const MedicalReportAttachmentsChangedReasonValues = ["UPLOAD_STATUS_CHANGED", "UPLOAD_SESSION_REVERTED"] as const
export type MedicalReportAttachmentsChangedReason = typeof MedicalReportAttachmentsChangedReasonValues[number]

export const MedicalReportTypeValues = ["MEDICAL_REPORT", "OTHER"] as const
export type MedicalReportType = typeof MedicalReportTypeValues[number]

export const MedicationUnitValues = ["PC", "ML", "MG", "GTT", "PUFF", "IU", "PRN"] as const
export type MedicationUnit = typeof MedicationUnitValues[number]

export const MessageRoleValues = ["DOCTOR", "PATIENT"] as const
export type MessageRole = typeof MessageRoleValues[number]

export const MobilePlatformValues = ["ANDROID", "IOS"] as const
export type MobilePlatform = typeof MobilePlatformValues[number]

export const NotBillableReasonValues = ["ADMINISTRATIVE", "INCOMPLETE_CONSULTATION", "OTHER_REASON"] as const
export type NotBillableReason = typeof NotBillableReasonValues[number]

export const NutritionalConditionValues = ["OBESITY", "METABOLIC_DISEASES", "CARDIOVASCULAR_DISEASES", "DISEASES_OF_THE_DIGESTIVE_SYSTEM", "KIDNEY_DISEASES", "MALNUTRITION_AND_MALNOURISHMENT_CONDITIONS", "FOOD_ALLERGIES_OR_ALLERGIC_REACTIONS_TO_FOOD_COMPONENTS"] as const
export type NutritionalCondition = typeof NutritionalConditionValues[number]

export const ObesityTherapyValues = ["INDIVIDUAL_THERAPY", "MULTIPROFESSIONAL_STRUCTURED_INDIVIDUAL_THERAPY"] as const
export type ObesityTherapy = typeof ObesityTherapyValues[number]

export const OccurrenceValues = ["FIRST_OCCURRENCE", "RECURRENCE"] as const
export type Occurrence = typeof OccurrenceValues[number]

export const OpenAiPromptTypeValues = ["NEXT_BEST_QUESTION_ADULT", "NEXT_BEST_QUESTION_CHILD", "TRANSLATE_ADMIN", "TRANSLATE_DOCTOR", "TRANSLATE_PATIENT", "MAGIC_WAND_ANAMNESE_ADULT", "MAGIC_WAND_ANAMNESE_CHILD", "MAGIC_WAND_EXPLAIN_ADULT", "MAGIC_WAND_EXPLAIN_CHILD", "MAGIC_WAND_NICE_SPEAK_ADULT", "MAGIC_WAND_NICE_SPEAK_CHILD", "MAGIC_WAND_THERAPY_ADULT", "MAGIC_WAND_THERAPY_CHILD", "QUESTIONNAIRE_SUMMARIZER_CHAT_ADULT", "QUESTIONNAIRE_SUMMARIZER_CHAT_CHILD", "QUESTIONNAIRE_SUMMARIZER_ANAMNESIS", "CHAT_SUMMARIZER_ANAMNESIS", "REFERRAL_LETTER_COPILOT", "CHAT_CASE_SUMMARY_CONFIRMATION_MESSAGE_CHILD", "CHAT_CASE_SUMMARY_CONFIRMATION_MESSAGE_ADULTS", "CHAT_HEALTH_INFORMATION_COPILOT", "NEXT_BEST_QUESTION_TMP", "TELEMEDICINE_CLASSIFIER", "CALL_CASE_SUMMARY_ANAMNESIS", "CONSULTATION_REPORT", "PRESCRIPTION_SUMMARIZER", "DERMATOLOGY_SUMMARIZER"] as const
export type OpenAiPromptType = typeof OpenAiPromptTypeValues[number]

export const OpenAiResponseFormatValues = ["TEXT", "JSON"] as const
export type OpenAiResponseFormat = typeof OpenAiResponseFormatValues[number]

export const OtherInterestStateValues = ["UNKNOWN", "CLAIMED"] as const
export type OtherInterestState = typeof OtherInterestStateValues[number]

export const PartnerTypeValues = ["MEAS", "SPITEX", "PHARMACY"] as const
export type PartnerType = typeof PartnerTypeValues[number]

export const PartyTypeValues = ["NATURAL_PERSON", "JURISTIC_PERSON", "UNKNOWN"] as const
export type PartyType = typeof PartyTypeValues[number]

export const PatientFileLockActionValues = ["TAKEN", "RELEASED", "REQUESTED", "REQUEST_COUNTDOWN", "ALLOWED", "DENIED", "CANCEL_REQUEST"] as const
export type PatientFileLockAction = typeof PatientFileLockActionValues[number]

export const PatientRecordExportStatusValues = ["GENERATING_SUMMARY", "SUMMARY_READY", "PACKAGING", "DELIVERING", "COMPLETED", "DISCARDED", "FAILED"] as const
export type PatientRecordExportStatus = typeof PatientRecordExportStatusValues[number]

export const PaymentValues = ["TARMED_B2B", "TARMED_B2C", "HYBRID_B2B", "FLAT_RATE_B2B"] as const
export type Payment = typeof PaymentValues[number]

export const PermissionPurposeValues = ["LEGACY_CALL_RECORDING_AND_PROCESSING", "CALL_RECORDING_FOR_DOCUMENTATION", "CALL_RECORDING_FOR_QUALITY_AND_TRAINING", "INVOICE_COPY_EMAIL", "TERMS_AND_CONDITIONS_MOBILE_APP", "TERMS_AND_CONDITIONS_WEB_BOOKING", "LEGAL_GUARDIAN_MOBILE_APP", "NOTIFICATIONS_APPOINTMENT_RELATED_SMS", "NOTIFICATIONS_APPOINTMENT_RELATED_MOBILE_APP", "NOTIFICATIONS_PERSONAL_HEALTH_MOBILE_APP", "NOTIFICATIONS_NEWS_MOBILE_APP", "USER_TRACKING_MOBILE_APP", "TERMS_AND_CONDITIONS_PARTNER_PORTAL", "DATA_TRANSFER_PARTNER_PORTAL", "DATA_TRANSFER_MEDI_SERVICE"] as const
export type PermissionPurpose = typeof PermissionPurposeValues[number]

export const PharmacyAffiliationValues = ["BENU", "GALENICA", "TOP_PHARM"] as const
export type PharmacyAffiliation = typeof PharmacyAffiliationValues[number]

export const PointOfCareTypeValues = ["TELECARE", "GENERAL_PRACTITIONER", "SPECIALIST", "HOSPITAL_ELECTIVE", "HOSPITAL_EMERGENCY_ROOM", "MEDICAL_EMERGENCY_OR_PERMANENCE", "EMERGENCY_CALL", "INCOMPLETE_TELECONSULTATION", "EXTERNAL_ASSISTANCE"] as const
export type PointOfCareType = typeof PointOfCareTypeValues[number]

export const PregnancyStatusValues = ["UNKNOWN", "NOT_PREGNANT", "PREGNANT"] as const
export type PregnancyStatus = typeof PregnancyStatusValues[number]

export const PregnantStatusValues = ["PREGNANT", "NOT_PREGNANT", "NOT_ENQUIRED"] as const
export type PregnantStatus = typeof PregnantStatusValues[number]

export const PrescriptionRepetitionValues = ["FIRST", "SECOND", "THIRD", "FOURTH"] as const
export type PrescriptionRepetition = typeof PrescriptionRepetitionValues[number]

export const PrescriptionStatusValues = ["NOT_SENT", "SENT", "DELIVERY", "READY_FOR_PICKUP_LATER", "READY_FOR_PICKUP", "READY_FOR_DELIVERY_LATER", "READY_FOR_DELIVERY", "COLLECTED", "CANCELLED"] as const
export type PrescriptionStatus = typeof PrescriptionStatusValues[number]

export const PreventionProgramDismissReasonValues = ["PATIENT_IS_NOT_INTERESTED", "PATIENT_SELF_ORGANIZES", "PATIENT_IS_ALREADY_IN_PROGRAM", "PATIENT_HAS_NO_INCREASED_RISK", "APPOINTMENT_ALREADY_BOOKED_THROUGH_MEDGATE"] as const
export type PreventionProgramDismissReason = typeof PreventionProgramDismissReasonValues[number]

export const PreventionProgramEngagementStatusValues = ["BOOKED", "DISMISSED"] as const
export type PreventionProgramEngagementStatus = typeof PreventionProgramEngagementStatusValues[number]

export const PreventionProgramTreatmentPlanTemplateCaseValues = ["REGION", "ZIP", "NO_REGION_NO_ZIP"] as const
export type PreventionProgramTreatmentPlanTemplateCase = typeof PreventionProgramTreatmentPlanTemplateCaseValues[number]

export const ProcessedStatusValues = ["ONGOING", "FAILED", "SUCCEEDED"] as const
export type ProcessedStatus = typeof ProcessedStatusValues[number]

export const ProductCodeValues = ["ITC", "FLX", "MCS", "DEM", "TGP", "B2C"] as const
export type ProductCode = typeof ProductCodeValues[number]

export const ProductStatusValues = ["INACTIVE", "SCHEDULED", "ACTIVE"] as const
export type ProductStatus = typeof ProductStatusValues[number]

export const ProgressNoteKindValues = ["MEDICAL", "ADMINISTRATIVE"] as const
export type ProgressNoteKind = typeof ProgressNoteKindValues[number]

export const ProgressNoteKindFilterValues = ["MEDICAL", "ADMINISTRATIVE"] as const
export type ProgressNoteKindFilter = typeof ProgressNoteKindFilterValues[number]

export const QmsMediaRequestedValues = ["PICTURE", "VIDEO", "MEDICAL_RECORD", "NONE"] as const
export type QmsMediaRequested = typeof QmsMediaRequestedValues[number]

export const QmsSummaryCriticalityValues = ["CRITICAL", "WARNING", "REVIEW", "INFO"] as const
export type QmsSummaryCriticality = typeof QmsSummaryCriticalityValues[number]

export const QmsTypeAiRecommendationValues = ["TLC", "GP"] as const
export type QmsTypeAiRecommendation = typeof QmsTypeAiRecommendationValues[number]

export const QuestionnaireCategoryValues = ["TMC", "ASYNC"] as const
export type QuestionnaireCategory = typeof QuestionnaireCategoryValues[number]

export const QuestionnaireFlavourValues = ["CHAT", "ANAMNESIS"] as const
export type QuestionnaireFlavour = typeof QuestionnaireFlavourValues[number]

export const QuestionnaireTypeValues = ["QMS", "SURVEY_LAB"] as const
export type QuestionnaireType = typeof QuestionnaireTypeValues[number]

export const QuestionTypeValues = ["SELECTION", "SLIDER", "NUMERIC", "RATING", "FREE_TEXT"] as const
export type QuestionType = typeof QuestionTypeValues[number]

export const RapidTestValues = ["COVID19", "LACTOSE_INTOTERANCE", "STREP_A"] as const
export type RapidTest = typeof RapidTestValues[number]

export const ReasonValues = ["SICKNESS", "ACCIDENT", "IVMV"] as const
export type Reason = typeof ReasonValues[number]

export const ReasonForChoosingTypeValues = ["TIME", "INFRASTRUCTURE", "PATIENT_REQUEST"] as const
export type ReasonForChoosingType = typeof ReasonForChoosingTypeValues[number]

export const ReasonForNutritionalValues = ["SICKNESS", "ACCIDENT", "IVMV"] as const
export type ReasonForNutritional = typeof ReasonForNutritionalValues[number]

export const ReasonForPhysiotherapyValues = ["SICKNESS", "ACCIDENT", "IVMV"] as const
export type ReasonForPhysiotherapy = typeof ReasonForPhysiotherapyValues[number]

export const ReasoningEffortValues = ["LOW", "MEDIUM", "HIGH"] as const
export type ReasoningEffort = typeof ReasoningEffortValues[number]

export const ReferralReasonValues = ["APPOINTMENT_REGISTRATION", "EMERGENCY_REGISTRATION", "APPOINTMENT_POST_REGISTRATION", "EMERGENCY_POST_REGISTRATION", "REFERRAL"] as const
export type ReferralReason = typeof ReferralReasonValues[number]

export const ReferralToGeneralPractitionerValues = ["NONE", "MPN", "INSURANCE_LIST"] as const
export type ReferralToGeneralPractitioner = typeof ReferralToGeneralPractitionerValues[number]

export const ReferralToSpecialistValues = ["NONE", "MPN", "INSURANCE_LIST"] as const
export type ReferralToSpecialist = typeof ReferralToSpecialistValues[number]

export const ReferredByValues = ["MEDGATE", "SELF", "CARE_PROVIDER"] as const
export type ReferredBy = typeof ReferredByValues[number]

export const RelationTypeValues = ["EMPLOYED_BY", "AFFILIATED_WITH", "BILLS_VIA"] as const
export type RelationType = typeof RelationTypeValues[number]

export const RequestExaminationValues = ["HAND_AP_OBLIQUE", "HAND_LAT", "WRIST_AP_LAT", "LOWERARM_AP_LAT", "ELLBOW_AP_LAT", "UPPERARM_AP_LAT", "SHOULDER_AP_NEER", "CLAVICLE_AP_TANGENTIAL", "TOE_AP_OBLIQUE", "FOOT_AP_OBLIQUE", "FOOT_LAT", "UAJ_AP_LAT", "LOWER_LEG_JOINT", "KNEE_AP_LAT", "PATELLA_AXIAL", "UPPER_LEG_JOINT", "PELVIS_AP", "HIPJOINT_AXIAL", "PELVIS_STANDARD", "CHEST_X_RAY_TWO_PLANES"] as const
export type RequestExamination = typeof RequestExaminationValues[number]

export const RequestTypeValues = ["NONE", "SICK_LEAVE_CERTIFICATE", "REFERRAL", "PRESCRIPTION", "ONBOARDING_CALL", "PLANNED_SELF_REFERRAL", "SICK_LEAVE_FOR_LEGAL_GUARDIAN", "PRESCRIPTION_ASTHMA", "PRESCRIPTION_HAY_FEVER", "PRESCRIPTION_MIGRAINE", "PRESCRIPTION_ATHLETES_FOOT", "PRESCRIPTION_HYPOTHYROIDISM", "PRESCRIPTION_CONTRACEPTIVE_PILL", "PRESCRIPTION_ERECTILE_DYSFUNCTION", "PRESCRIPTION_URINARY_TRACT_INFECTION", "SKIN_CHECK", "PRESCRIPTION_BLOOD_PRESSURE", "PRESCRIPTION_HEARTBURN", "PRESCRIPTION_VAGINAL_MYCOSIS"] as const
export type RequestType = typeof RequestTypeValues[number]

export const ResolvedBetterDocUsageValues = ["ALLOWED", "NOT_ALLOWED", "REQUIRED"] as const
export type ResolvedBetterDocUsage = typeof ResolvedBetterDocUsageValues[number]

export const ScalarSerializationTypeValues = ["STRING", "BOOLEAN", "INT", "FLOAT", "OBJECT", "LIST"] as const
export type ScalarSerializationType = typeof ScalarSerializationTypeValues[number]

export const ServiceValues = ["CONSULTATION", "PREVENTION_ASSESSMENT", "KIDS_LINE", "EMERGENCY_LINE", "STUDY_CALL", "ADMINISTRATIVE_REQUEST", "TELE_GENERAL_PRACTITIONER", "MEDGATE_CONNECT", "PSYCHOSOCIAL"] as const
export type Service = typeof ServiceValues[number]

export const ServiceSpecialtyValues = ["NONE", "DERMATOLOGY", "GYNAECOLOGY", "CARDIOLOGY", "LONG_COVID", "OTORHINOLARYNGOLOGY", "PEDIATRICS", "UROLOGY", "VACCINATION_AND_TRAVEL_ADVICE"] as const
export type ServiceSpecialty = typeof ServiceSpecialtyValues[number]

export const ShiftInformationValues = ["OPERATIVE_SHIFT", "NON_OPERATIVE_SHIFT", "MEDICAL_SUPERVISOR"] as const
export type ShiftInformation = typeof ShiftInformationValues[number]

export const ShiftPlanRoleFilterValues = ["DOCTORS_AND_MEDICAL_SUPERVISORS", "NURSING_PROFESSIONALS", "CALL_CENTER_AGENTS"] as const
export type ShiftPlanRoleFilter = typeof ShiftPlanRoleFilterValues[number]

export const ShiftTypeValues = ["GENERAL", "DERMATOLOGY", "CARDIOLOGY", "GYNAECOLOGY", "UROLOGY", "KIDS_LINE", "CHATS", "VACCINATION_PRESCRIPTION", "SPORTS", "BOOK_A_DOC_AT_PHARMACY", "MEDICAL_SUPERVISOR"] as const
export type ShiftType = typeof ShiftTypeValues[number]

export const SickLeaveReasonValues = ["SICKNESS", "ACCIDENT"] as const
export type SickLeaveReason = typeof SickLeaveReasonValues[number]

export const SideValues = ["LEFT", "RIGHT"] as const
export type Side = typeof SideValues[number]

export const SkillSpecialtyValues = ["DERMATOLOGY", "GYNAECOLOGY", "OTORHINOLARYNGOLOGY", "UROLOGY", "PEDIATRICS", "STUDY", "CARDIOLOGY", "SPORTS_MEDICINE", "LONG_COVID", "SURGERY", "RHEUMATOLOGY", "GENERAL_INTERNAL_MEDICINE", "VACCINATION_ADVICE", "TELE_GENERAL_PRACTITIONER"] as const
export type SkillSpecialty = typeof SkillSpecialtyValues[number]

export const SmokingHabitValues = ["NOT_SPECIFIED", "REGULARLY", "IN_COMPANY", "NO_LONGER", "NEVER"] as const
export type SmokingHabit = typeof SmokingHabitValues[number]

export const SortEnumTypeValues = ["ASC", "DESC"] as const
export type SortEnumType = typeof SortEnumTypeValues[number]

export const SteeringLevelValueValues = ["ZERO", "ONE", "TWO", "THREE", "FOUR", "MINUS_ONE"] as const
export type SteeringLevelValue = typeof SteeringLevelValueValues[number]

export const SurveyLabScoreLevelValues = ["REVIEW", "INFO", "WARNING", "CRITICAL"] as const
export type SurveyLabScoreLevel = typeof SurveyLabScoreLevelValues[number]

export const SymptomValues = ["PAIN", "PAIN_RELATED_MAL_POSITION", "LIMITED_RANGE_OF_MOTION", "FUNCTIONAL_DISORDER"] as const
export type Symptom = typeof SymptomValues[number]

export const TeamValues = ["PEDIATRICS", "DERMATOLOGY", "PSYCHOSOCIAL"] as const
export type Team = typeof TeamValues[number]

export const TeleConsultationValues = ["ALLOWED", "NOT_ALLOWED", "REQUIRED"] as const
export type TeleConsultation = typeof TeleConsultationValues[number]

export const TestJobParameterKindValues = ["NUMBER", "DATE"] as const
export type TestJobParameterKind = typeof TestJobParameterKindValues[number]

export const TestScheduledJobNameValues = ["SEND_MAIL_FOR_FAIL_TO_CONCLUDE_APPOINTMENT_JOB", "CLOSE_STALE_CHAT_APPOINTMENTS_JOB", "AUTO_RELEASE_EXPIRED_PATIENT_FILE_LOCKS_JOB", "AUTOMATICALLY_UPDATE_STEERING_LEVELS_JOB", "RECONCILE_STALE_VIDEO_CALLS_JOB", "REMOVE_CHILD_PROFILE_ON_ADULTHOOD_JOB", "SCHEDULE_UPDATE_CITY_LOOKUP_JOB", "SEND_WELCOME_LETTER_JOB", "SOCIAL_SECURITY_NUMBER_SYNC_JOB", "SCHEDULE_SEND_INFO_PACKAGE_LINK_JOB"] as const
export type TestScheduledJobName = typeof TestScheduledJobNameValues[number]

export const TherapyPrescriptionValues = ["PSYCHOTHERAPY_PRESCRIPTION1", "CRISIS_INTERVENTION_SHORT_THERAPY", "PSYCHOTHERAPY_PRESCRIPTION2", "TREATMENT"] as const
export type TherapyPrescription = typeof TherapyPrescriptionValues[number]

export const TimeToTreatTypeValues = ["URGENT", "WITHIN6H", "WITHIN12H", "WITHIN24H", "WITHIN48H", "WITHIN14DAYS", "LATER"] as const
export type TimeToTreatType = typeof TimeToTreatTypeValues[number]

export const TimeWindowValues = ["REQUIRED", "NOT_REQUIRED"] as const
export type TimeWindow = typeof TimeWindowValues[number]

export const TimeWindowTypeValues = ["MANUAL", "PROGRESS_NOTE_LINKED", "EMERGENCY_POST_REGISTRATION", "APPOINTMENT_POST_REGISTRATION"] as const
export type TimeWindowType = typeof TimeWindowTypeValues[number]

export const TranscriptSpeakerValues = ["PATIENT", "AGENT"] as const
export type TranscriptSpeaker = typeof TranscriptSpeakerValues[number]

export const TreatmentReasonValues = ["SICKNESS", "ACCIDENT", "MATERNITY", "PREVENTION", "CONGENITAL_DEFECT"] as const
export type TreatmentReason = typeof TreatmentReasonValues[number]

export const TreatmentUnitPerDayValues = ["ONCE", "TWICE"] as const
export type TreatmentUnitPerDay = typeof TreatmentUnitPerDayValues[number]

export const UrgencyValues = ["NORMAL", "MEDICAL_URGENT", "MEDICAL_ACUTE"] as const
export type Urgency = typeof UrgencyValues[number]

export const UrineDiagnosticValues = ["BETA_HCG", "MICROALBUMIN", "STIX_SEDIMENT", "URICULT"] as const
export type UrineDiagnostic = typeof UrineDiagnosticValues[number]

export const UserRoleValues = ["NONE", "CALL_CENTER_AGENT", "CUSTOMER_SERVICE_CENTER", "NURSING_PROFESSIONAL", "DOCTOR", "MEDICAL_SUPERVISOR", "SOFIA_ADMIN_TECHNICAL_ADMIN", "SOFIA_ADMIN_BUSINESS_ADMIN", "SOFIA_ADMIN_BUSINESS_EDITOR", "SOFIA_ADMIN_MEDICAL_ADMIN", "SOFIA_ADMIN_AI_ADMIN", "SOFIA_ADMIN"] as const
export type UserRole = typeof UserRoleValues[number]

export const VerifyMedicationStatusValues = ["NOT_ENQUIRED", "NONE", "SOME"] as const
export type VerifyMedicationStatus = typeof VerifyMedicationStatusValues[number]

export const WaitingTimeStatusValues = ["CALCULATED", "EXCEEDS_MAXIMUM"] as const
export type WaitingTimeStatus = typeof WaitingTimeStatusValues[number]

export const WebNotificationKindValues = ["PATIENT_FILE_LOCK_TAKEN", "PATIENT_FILE_LOCK_REQUESTED", "APPOINTMENT_CONCLUSION_FAILED"] as const
export type WebNotificationKind = typeof WebNotificationKindValues[number]

export const WorkCapacityTypeValues = ["HOURS_PER_WEEK", "EMPLOYMENT_RATE"] as const
export type WorkCapacityType = typeof WorkCapacityTypeValues[number]

export const WorkingTypeValues = ["HOURLY", "CLOSED", "OPEN24_HOURS"] as const
export type WorkingType = typeof WorkingTypeValues[number]

